import { useTranslation } from 'react-i18next';

import { IonCol, IonRow } from '@ionic/react';

import { TSButton } from '../../components/atomic/TSButton/TSButton';
import { TSModal } from '../../components/atomic/TSModal/TSModal';
import { useCapturePostHog } from '../../hooks/useCapturePostHog';

interface AdvocateChatEndedModalProps {
  isOpen: boolean;
  onClose: () => void;
  message: string;
  subHeader: string;
}

export const AdvocateChatEndedModal = ({ isOpen, message, subHeader, onClose }: AdvocateChatEndedModalProps) => {
  const { t } = useTranslation();
  const { capturePostHogCustomEvent } = useCapturePostHog();

  return (
    <TSModal
      className="report-chat-modal"
      isOpen={isOpen}
      mainContent={
        <>
          <IonRow className="ion-padding-top">
            <IonCol className="headline-small text-bold">Chat ended</IonCol>
          </IonRow>
          <IonRow>
            <IonCol>
              <span>{subHeader}</span>
              <span dangerouslySetInnerHTML={{ __html: message }} />
            </IonCol>
          </IonRow>
          <IonRow className="ion-padding-vertical ion-justify-content-center">
            <TSButton
              data-testid="advocate-chat-ended-ok-btn"
              variant="black"
              onClick={() => {
                onClose();
                capturePostHogCustomEvent('AdvocateChatEndedModal clicked ok');
              }}
            >
              {t('generic.ok')}
            </TSButton>
          </IonRow>
        </>
      }
    />
  );
};
